<template>
    <b-container fluid class="">
        <h1 class="m-3">
            {{ title }}
        </h1>
        <commonActions :data-ready="dataReadyTables" :filename-prefix="title" :dateDimension="dateDimension"
            :useTimeFilter="false" :allow-future-date="true" @commonFiltersUpdated="commonFiltersUpdated($event)"
            @clickDownloadPdf="downloadPdf($event)" @clickDownloadExcel="downloadExcel($event)"
            @clickDownloadCsv="downloadCsv($event)" />
        <table-renderer v-for="data of tablesData" :key="data.tableNumber" :data-table="data.dataTable"
            ref="tableRenderers" :dimension-fields="dimensionColumnsTables" :measure-fields="measureColumnsTables"
            :table-header="data.tableHeader" :group-headers="groupHeaders" :top-group-headers="topGroupHeaders"
            :default-sorted-column="dateDimension" :totals-data="data.totalsData" :data-ready="dataReadyTables" />
    </b-container>
</template>


<script>

import i18n from "@/plugins/vue-i18n.js";
import { Cake } from '@/router/routeNames';
import TableRenderer from '@/components/TableRenderer.vue';
import commonActions from '@/components/pages/commonActions.vue';
import TableTools from '@/utils/tableTools';
import paths from '@/router/pathConstants';
import dimensionEnum from '@/model/dimensionEnum';
import mesureEnum from '@/model/mesureEnum';
import Tools from '@/utils/tools';
import { calculatedColumnsEnum } from '@/model/columnsEnums';
import { columnTypeEnum } from '@/model/columnsEnums';
import { numberFormat, formatAmount } from "@/filter/numberFormat";
import { dateFormat, dateFormatEnum } from "@/filter/dateFormat";
import _ from "lodash";
import abortMixin from "@/mixins/abortMixin";

export default {
    name: Cake,
    mixins: [abortMixin],
    components: {
        TableRenderer,
        commonActions
    },
    props: {
        /** Préfixe de l'identifiant de la table pour les exports ayant plusieurs groupes de tableaux */
        dateDimension: {
            type: String,
            default() {
                return dimensionEnum.OMNIPLAYEVENT_EVENTBUSINESSDATE;
            },
        }
    },
    data() {
        return {
            commonFilters: [],
            siteValues: [],
            timeDimension: null,
            dataReadyTables: false,
            dimensionColumnsTables: [],
            measureColumnsTables: [],
            groupHeaders: [],
            topGroupHeaders: [],

            tablesData: [],
        }
    },

    mounted() {
    },
    computed: {
        title() {
            return this.$t("title.cake");
        },
    },
    methods: {
        commonFiltersUpdated(value) {
            this.commonFilters = value.filters;
            this.siteValues = value.siteValues;
            this.timeDimension = value.timeDimension || null;
            this.updateTableList(this.commonFilters)
        },
        async updateTableList(filters) {
            try {
                const { signal } = this.resetAbortController();
                var self = this
                this.dataReadyTables = false;
                filters.push({
                    dimension: dimensionEnum.OMNIPLAYEVENT_ISBIRTHDAY,
                    operator: "equals",
                    values: [
                        "1"
                    ]
                });

                // Initialisation des objets contenant toutes les données pour chaque site :
                // permet d'afficher dès maintenant les entêtes de tableaux et le loader pour indiquer que les requêtes sont en cours
                this.tablesData = this.siteValues.map((site, i) => {
                    return {
                        tableNumber: i.toString(),
                        tableHeader: site.label,
                        tableHeaderId: site.id,
                        dataTable: [],
                        totalsData: {},
                    };
                });
                let measures = [
                    mesureEnum.OMNIPLAYEVENT_NBCAKE
                ]
                let dimensions = [
                    dimensionEnum.SITE,
                    this.dateDimension,
                    dimensionEnum.OMNIPLAYEVENT_CAKE
                ];

                let query = {
                    measures: measures,
                    dimensions: dimensions,
                    filters: filters,
                    timeDimensions: this.timeDimension
                        ? [{ ...this.timeDimension, dimension: this.dateDimension }]
                        : [],
                };

                let results = await TableTools.Helper.doRequest(query, { signal });
                const index = dimensions.indexOf(dimensionEnum.SITE);
                dimensions.splice(index, 1);
                this.initDisplayTables(measures, dimensions);


                self.siteValues.forEach((site) => {
                    var table = self.tablesData.find(
                        (tab) => tab.tableHeaderId === site.id
                    );
                    table.dataTable = results.filter(
                        (result) => result[dimensionEnum.SITE] === site.id
                    );
                });

                self.dataReadyTables = true;

                this.dataReadyTables = true;
            } catch (error) {
                if (this.isAbortError(error)) return;
                Tools.Alerts.Error(this.$swal, error);
            }
        },
        initDisplayTables(measureColumns, dimensionColumns) {
            const self = this;

            //Initialisation des colonnes affichées
            self.measureColumnsTables = this.constructColumnTable(measureColumns, columnTypeEnum.MEASURE);
            this.dimensionColumnsTables = this.constructColumnTable(dimensionColumns, columnTypeEnum.DIMENSION);
        },
        constructColumnTable(fullKeys, type) {
            var columnTable = fullKeys.map((fullKey) => {


                var column = {
                    key: fullKey,
                    label: i18n.t(fullKey),
                    type: type,
                    formatter: (value) => {
                        return this.valueFormatter(value, fullKey);
                    },
                };

                return column;
            });
            return columnTable;
        },
        valueFormatter(value, key, displayZero = false) {

            if (!isNaN(value)) return numberFormat(value, key, displayZero);
            else if (TableTools.Helper.isDate(value)) {
                return dateFormat(value, key);
            }

            var getFormat = value && value.match(/^#([\d€])#/);
            if (getFormat) {
                value = parseFloat(value.substring(getFormat[0].length));
                //Le format est forcé pour la cellule
                if (getFormat[1] === "€") {
                    return formatAmount(value);
                } else {
                    //nombre de décimales attendues
                    return value.toFixed(getFormat[1]);
                }
            }
            return value;
        },
        downloadPdf(data) {
            if (this.dataReadyTables) {
                this.storeExportData(data.filename, data.subtitles);
                window.open(paths.EXPORT_PDF, "_blank");
            }
        },
        downloadExcel(data) {
            if (this.dataReadyTables) {
                this.storeExportData(data.filename, data.subtitles);
                window.open(paths.EXPORT_EXCEL, "_blank");
            }
        },
        downloadCsv(data) {
            if (this.dataReadyTables) {
                this.storeExportData(data.filename, data.subtitles);
                window.open(paths.EXPORT_CSV, "_blank");
            }
        },
        storeExportData(filename, subtitles) {
            const self = this;
            let datasForExport = [];

            self.tablesData.forEach((table, index) => {
                const renderer = self.$refs.tableRenderers?.[index];
                const sortKey = renderer?.sortedColumn || self.defaultSortedColumnTables;

                const data = TableTools.Helper.assembleExportDataTable(
                    table.dataTable,
                    self.dimensionColumnsTables,
                    self.measureColumnsTables,
                    self.groupHeaders,
                    table.tableHeader,
                    sortKey,
                    null,
                    table.totalsData
                );

                datasForExport.push(data);
            });

            TableTools.Helper.storeExportData(
                datasForExport,
                self.title,
                subtitles,
                filename,
                null,
                null,
                5
            );
        },
    }
}

</script>
